import React, { useState, useEffect } from "react";
import { Card, Input } from "antd";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import StandardButton from "../components/StandardButton";

const TokenCounter = () => {
  const { t } = useTranslation();
  const [text, setText] = useState(t("sample_text_for_token_counter"));
  const [tokenCount, setTokenCount] = useState(0);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const id = searchParams.get("share");
    if (id) {
      fetch(`${process.env.REACT_APP_API_BASE_URL}/api/tools/token-counter/share/${id}`)
        .then(res => res.json())
        .then(data => {
          if (data.text && data.tokenCount !== undefined) {
            setText(data.text);
            setTokenCount(data.tokenCount);
          }
        });
    }
  }, []);

  useEffect(() => {
    if (text.trim()) {
      countTokens(text);
    } else {
      setTokenCount(0);
    }
  }, [text]);

  const countTokens = async (inputText) => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/tools/token-counter`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ text: inputText }),
      });
      const data = await res.json();
      setTokenCount(data.tokenCount);
    } catch {
      toast.error(t("error_occurred"));
    }
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(`${t("token_count")}: ${tokenCount}`);
      toast.success(t("copy_success"));
    } catch {
      toast.error(t("failed_to_copy"));
    }
  };

  const handleShare = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/tools/token-counter/share`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ text, tokenCount }),
      });
      const data = await res.json();
      const link = `${window.location.origin}/tools/token-counter?share=${data.id}`;
      await navigator.clipboard.writeText(link);
      toast.success(t("share_success"));
    } catch {
      toast.error(t("share_failed"));
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-0">
      <Header />
      <div className="max-w-5xl mx-auto">
        <Card className="p-6 rounded-xl shadow-lg space-y-6">
          <Input.TextArea
            rows={8}
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder={t("enter_text_to_count_tokens")}
          />
          <div className="text-lg font-medium mt-4">
            {t("token_count")}: {tokenCount}
          </div>

          <div className="flex gap-4 mt-6">
            <StandardButton
              onClick={handleCopy}
              type="secondary"
              variant="outlined"
              size="small"
            >
              {t("copy_button")}
            </StandardButton>
            <StandardButton
              onClick={handleShare}
              type="secondary"
              variant="outlined"
              size="small"
            >
              {t("share_button")}
            </StandardButton>
          </div>
        </Card>
        <Footer />
      </div>
    </div>
  );
};

export default TokenCounter;